import { OrderAssetAvailability } from "../types/OrderAssetAvailability";

export interface OrderProgressData {
    total: number;
    completed: number;
    percentage: number;
}

export const calculateOrderProgress = (
    video: OrderAssetAvailability,
    soundtracks: OrderAssetAvailability[],
    subtitles: OrderAssetAvailability[]
): OrderProgressData => {
    const allAssets = [video, ...soundtracks, ...subtitles];
    const total = allAssets.length;
    const completed = allAssets.filter((availability) => availability === OrderAssetAvailability.FullMatch).length;
    const percentage = total > 0 ? completed / total : 0;

    return { total, completed, percentage };
};
